import { apiFetch } from "@/api/APIClient";
import { useMutation } from "@tanstack/react-query";

interface ExchangeMagicLinkTokenRequest {
  token: string;
}

interface ExchangeMagicLinkTokenResponse {
  accessToken: string;
  refreshToken: string;
  redirectPath: string;
}

const exchangeMagicLinkToken = async (
  data: ExchangeMagicLinkTokenRequest
): Promise<ExchangeMagicLinkTokenResponse> => {
  const response = await apiFetch("/api/auth/magic-link/exchange", {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "로그인 링크를 확인하지 못했습니다. 다시 시도해주세요.");
  }

  return response.json();
};

export const useExchangeMagicLinkToken = () => {
  return useMutation<ExchangeMagicLinkTokenResponse, Error, ExchangeMagicLinkTokenRequest>({
    mutationFn: exchangeMagicLinkToken,
  });
};
